import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import HeaderLogged from '../../../../../components/header_logged'
import FormEdit from '../../../../../components/auth/institucional/locais/listar/form_edit'
import Head from '../../../../../components/head'


function EditarLocaisScreen () {
    return (
        <Fragment>
            <Head titulo="Editando Órgão Municipal" />
            <HeaderLogged />
            <Container>
                <FormEdit />
            </Container>
        </Fragment>
    );
}

export default EditarLocaisScreen;